var map = {
	"./Banner.png": "b79b",
	"./Flow.png": "b3f1",
	"./Panels.png": "e13f",
	"./Rollo.png": "328b",
	"./Slides.png": "beca",
	"./back.svg": "ccfe",
	"./bg.png": "d68e",
	"./close.svg": "bf37",
	"./constructor.svg": "5cfe",
	"./copyright1.png": "de86",
	"./copyright2.png": "0b75",
	"./delete.svg": "d739",
	"./dictionary.svg": "0ce8",
	"./download.svg": "6369",
	"./edit.svg": "6582",
	"./empty-folder.svg": "4bd4",
	"./emptyFolder.jpg": "daa5",
	"./filter.svg": "5ee4",
	"./folder.jpg": "8bcf",
	"./folder.svg": "abfe",
	"./folder_icon.svg": "6f6e",
	"./image.png": "e429",
	"./library.jpg": "12ae",
	"./librarytop.jpg": "2aa7",
	"./link.svg": "6bb3",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logoblack.png": "33fc",
	"./logout.svg": "309a",
	"./mask.png": "f863",
	"./no_preview.png": "65bf",
	"./no_preview_2.png": "1377",
	"./radio.svg": "1579",
	"./search.svg": "51f2",
	"./selected.svg": "53cf",
	"./sertificate.svg": "476b",
	"./video_preview.png": "0152",
	"./washi unique.png": "e0e4",
	"./welcomebg.jpg": "78d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aeb6";